export const mathRound = (amount: number) => {
  return Math.round(amount * 1000) / 1000
}
